import { connect } from "react-redux";

import { getAllClips, getCsvData, getSingleStream, sortHandVideo } from "../../../store/videogrid/duck";
import ClipsFilter from "./component";

const ClipsFilterContainer = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  { getAllClips, sortHandVideo, getSingleStream, getCsvData },
)(ClipsFilter);

export default ClipsFilterContainer;
